/**
 * Iter52.63c · C2 · Campo numérico que NO admite negativos.
 *
 * El 52.63 solo puso `min`, que no impide teclear «−0,38». Aquí se bloquea
 * el signo y la notación científica al teclear y al pegar, y si el valor
 * queda por debajo del mínimo se muestra el error en rojo bajo el campo
 * (el formulario usa `valorInvalido` para desactivar el botón de confirmar).
 */
import React from 'react';

export const valorInvalido = (v, min = 0) => {
  if (v === '' || v === null || v === undefined) return false;
  const n = Number(v);
  return Number.isNaN(n) || n < min;
};

export const InputNumeroPositivo = ({
  value, onChange, min = 0, step = '0.01', testid,
  mensaje = 'No puede ser negativa',
}) => {
  const invalido = valorInvalido(value, min);
  const limpiar = (v) => String(v ?? '').replace(/[^0-9.,]/g, '').replace(',', '.');
  return <>
    <input
      className={`input ${invalido ? 'border-rose-400' : ''}`}
      type="number" step={step} min={min} value={value} data-testid={testid}
      onKeyDown={(e) => {
        if (['-', '+', 'e', 'E'].includes(e.key)) { e.preventDefault(); return; }
        // Iter52.63c · C2 · la coma decimal española se traduce a punto
        // (el input numérico del navegador la descartaba sin avisar).
        if (e.key === ',') {
          e.preventDefault();
          const actual = String(value ?? '');
          if (actual && !actual.includes('.')) onChange(`${actual}.`);
        }
      }}
      onPaste={(e) => {
        e.preventDefault();
        onChange(limpiar((e.clipboardData || window.clipboardData).getData('text')));
      }}
      onChange={(e) => onChange(limpiar(e.target.value))}
    />
    {invalido && <p className="text-xs font-bold text-rose-700 mt-1" data-testid={`${testid}-error`}>
      {min > 0 ? `Mínimo ${min}` : mensaje}
    </p>}
  </>;
};
